import { SimpleGuard } from 'interfaces/guards'
import { GetCCOnboardingStateAction } from 'components/features/creditCard/creditCardStore/actions'
import { personDataSelector } from 'components/features/creditCard/creditCardStore/selectors'


export const ccOnboardingGuard: SimpleGuard = {
  name: `Credit Card Onboarding Guard`,
  checker: (state) => {
    return personDataSelector(state) !== null
  },
  loader: (dispatch) => {
    dispatch(new GetCCOnboardingStateAction())
  },
}
